<template>
  <div>
    <div class="flex justify-between items-end">
      <sub-menu v-if="isNotSubChild" :title="title" :routes="routes"></sub-menu>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu.vue'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      title: this.$t('trading_comps').tTitle(),
      routes: this.getRoutes()
    }
  },
  components: {
    SubMenu,
  },
  watch: {
    Language() {
      this.updateRoutesAndTitle()
    }
  },
  computed: {
    isNotSubChild() {
      return this.routes.findIndex(route => route.name == this.$route.name) == -1 ? false : true
    },
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  methods: {
    getRoutes() {
      return [
        { path: '/competitions', title: 'in_progress', name: 'In Progress' },
        { path: '/competitions/finished', title: 'finished', name: 'Finished' },
        { path: '/competitions/upcoming', title: 'upcoming', name: 'Upcoming' },
      ]
    },
    updateRoutesAndTitle() {
      this.title = this.$t('trading_comps').tTitle()
      this.routes = this.getRoutes()
    }
  }
}
</script>
